import AirdropEligibility from "./AirdropEligibility";

export default AirdropEligibility;
